import { render, staticRenderFns } from "./Daily.vue?vue&type=template&id=65f8ba4d&scoped=true"
import script from "./Daily.vue?vue&type=script&lang=js"
export * from "./Daily.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65f8ba4d",
  null
  
)

export default component.exports